import {
  CONSUMER_PAYMENT_SCHEDULES,
  consumerQuotePremium,
  type ConsumerCoverageOption,
} from '@shared/consumerPlan';
import { approxMoney, money } from './format';

export interface CoverageLane {
  schedule: ConsumerPaymentSchedule;
  isAvailable: boolean;
  /** What the lane offers in one short phrase, from the quotes already loaded. */
  teaser: string | null;
}

function lowestPremium(options: ConsumerCoverageOption[]): number {
  return Math.min(...options.map(option => consumerQuotePremium(option.quote)));
}

/**
 * The three ways to pay, framed by what they give the consumer: lower monthly cost (ongoing),
 * balanced (10-pay) and maximum protection (one payment).
 */
export function coverageLanes(
  optionsBySchedule: Map<ConsumerPaymentSchedule, ConsumerCoverageOption[]>,
  singlePayPayout: number | null,
): CoverageLane[] {
  return CONSUMER_PAYMENT_SCHEDULES.map(schedule => {
    const options = optionsBySchedule.get(schedule) ?? [];
    if (!options.length) return { schedule, isAvailable: false, teaser: null };

    const from = money(lowestPremium(options));
    const teaser = {
      ongoing: `from ${from}/mo`,
      tenPay: `from ${from}/yr for 10 years`,
      singlePay: singlePayPayout ? `up to ${approxMoney(singlePayPayout)} toward care` : `one payment from ${from}`,
    }[schedule];
    return { schedule, isAvailable: true, teaser };
  });
}
